import { useApi } from '@omnipresentgroup/api';
import type {
  GetContractorsCostsRequest,
  GetContractorsCostsResponse,
  GetContractorsCostsResponseAPI,
} from '@omnipresentgroup/types';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { API_BASE, COSTS_API_PATH } from '../constants';
import {
  transformGetContractorsCostsRequestToAPI,
  transformGetContractorsCostsResponseFromAPI,
} from '../mappers';

export const useContractorsCosts = (
  parameters: GetContractorsCostsRequest,
  enabled?: boolean,
): UseQueryResult<GetContractorsCostsResponse, unknown> => {
  const { GET } = useApi();

  return useQuery({
    queryKey: [COSTS_API_PATH, ...Object.values(parameters)],
    queryFn: () =>
      GET<GetContractorsCostsResponseAPI>(
        `${API_BASE}/${COSTS_API_PATH}`,
        {},
        transformGetContractorsCostsRequestToAPI(parameters),
      ),
    enabled,
    select: (data) => transformGetContractorsCostsResponseFromAPI(data),
  });
};
